import * as React from "react";
import { format, parse, isValid } from "date-fns";
import { CalendarBlank, X } from "@phosphor-icons/react";
import { Button } from "@/components/ui/button";
import { Calendar } from "@/components/ui/calendar";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";
import { cn } from "@/lib/utils";

// Controlled date picker that reads/writes a "yyyy-MM-dd" string (matches existing form state & backend).
export function DatePicker({ value, onChange, placeholder = "Pick a date", className, disabled, clearable = false, "data-testid": testId }) {
  const [open, setOpen] = React.useState(false);
  const parsed = value ? parse(value, "yyyy-MM-dd", new Date()) : null;
  const selected = parsed && isValid(parsed) ? parsed : undefined;
  return (
    <div className={cn("relative inline-flex", className)}>
      <Popover open={open} onOpenChange={setOpen}>
        <PopoverTrigger asChild>
          <Button type="button" variant="outline" disabled={disabled} data-testid={testId}
            className={cn("w-full justify-start text-left font-normal", !selected && "text-muted-foreground", clearable && selected && "pr-8")}>
            <CalendarBlank size={15} className="mr-2 opacity-70" />
            {selected ? format(selected, "dd MMM yyyy") : placeholder}
          </Button>
        </PopoverTrigger>
        <PopoverContent className="w-auto p-0" align="start">
          <Calendar mode="single" showOutsideDays={false} selected={selected} defaultMonth={selected} initialFocus
            onSelect={(d) => { onChange(d ? format(d, "yyyy-MM-dd") : ""); setOpen(false); }} />
        </PopoverContent>
      </Popover>
      {clearable && selected && !disabled && (
        <button type="button" aria-label="Clear date" data-testid={testId ? `${testId}-clear` : undefined}
          onClick={(e) => { e.stopPropagation(); onChange(""); }}
          className="absolute right-2 top-1/2 -translate-y-1/2 text-muted-foreground hover:text-foreground">
          <X size={13} />
        </button>
      )}
    </div>
  );
}
